/*
  商品ドロワーの中の開閉(アコーディオン)だけを見る。
  ドロワー自体の出し入れ・スクロール固定・フォーカス管理・アニメーションは
  テーマの drawer-component に任せてある(挙動をハンバーガーと完全に同じにするため)。
*/
(function () {
  'use strict';

  var drawer = document.getElementById('Drawer-CecProducts');
  if (!drawer) return;

  // 2026-10-06 最下部「最近見た商品」。履歴は商品ページが localStorage「zest-recently-viewed」に
  // 入れる商品ID(新しい順)。開いてから取りに行くと 0.3秒+画像待ちが見えるため、
  //   1. ページ表示後の空き時間に先読みしてドロワーの中へ入れておく(開いた時には描画済み)
  //   2. 取得結果はタブ内(sessionStorage)に一時保存し、次のページでは通信なしで入れる
  //   3. 画像はドロワーのカード幅で選ばせ、先頭3枚は先に読んでおく
  var recent = drawer.querySelector('[data-cec-recent]');
  var recentKey = '';
  var CACHE_KEY = 'cec-bn-recent-v1';
  var CACHE_TTL = 10 * 60 * 1000; // 価格・在庫の古さを許す上限
  var EAGER_COUNT = 3;

  function readRecentIds() {
    var ids = [];
    try {
      ids = JSON.parse(window.localStorage.getItem('zest-recently-viewed') || '[]');
    } catch (err) {
      ids = [];
    }
    if (!Array.isArray(ids)) return [];
    var current = parseInt(recent.dataset.productId, 10);
    var limit = parseInt(recent.dataset.limit, 10) || 8;
    return ids
      .map(function (id) { return parseInt(id, 10); })
      .filter(function (id) { return id > 0 && id !== current; })
      .slice(0, limit);
  }

  function readCache(key) {
    try {
      var c = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      return c && c.key === key ? c : null;
    } catch (err) {
      return null;
    }
  }

  function writeCache(key, html) {
    try {
      window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key: key, html: html, t: Date.now() }));
    } catch (err) {
      // 容量超過・プライベートモードでは保存しないだけ
    }
  }

  function render(html) {
    var track = recent.querySelector('[data-cec-recent-track]');
    if (!track || !html) {
      recent.hidden = true;
      return;
    }
    var box = document.createElement('div');
    box.innerHTML = html;
    // カードの sizes は一覧(画面幅の半分)用。ドロワーでは 160px 以下なので小さい画像で足りる
    var imgs = box.querySelectorAll('.product-card__image--main img');
    Array.prototype.forEach.call(box.querySelectorAll('img[sizes]'), function (img) {
      img.setAttribute('sizes', '160px');
    });
    Array.prototype.forEach.call(imgs, function (img, i) {
      if (i < EAGER_COUNT) img.setAttribute('loading', 'eager');
    });
    track.innerHTML = '';
    while (box.firstChild) track.appendChild(box.firstChild);
    track.scrollLeft = 0;
    recent.hidden = false;
  }

  function loadRecent() {
    if (!recent) return;
    var ids = readRecentIds();
    var key = ids.join(',');
    if (!ids.length) {
      recentKey = key;
      recent.hidden = true;
      return;
    }
    var cached = readCache(key);
    if (key !== recentKey && cached) render(cached.html);
    if (key === recentKey || (cached && Date.now() - cached.t < CACHE_TTL)) {
      recentKey = key;
      return;
    }
    recentKey = key;
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    fetch(recent.dataset.url + encodeURIComponent(q))
      .then(function (res) {
        if (!res.ok) throw new Error('recent ' + res.status);
        return res.text();
      })
      .then(function (text) {
        if (key !== recentKey) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cards = doc.querySelector('[data-cec-recent-cards]');
        if (!cards || !cards.querySelector('.f-column')) {
          recent.hidden = true;
          return;
        }
        writeCache(key, cards.innerHTML);
        render(cards.innerHTML);
      })
      .catch(function (err) {
        recentKey = '';
        if (!cached) recent.hidden = true;
        console.error('[cec-bn-sheet] 最近見た商品の取得に失敗', err);
      });
  }

  // 2026-10-19 計測。カスタムピクセル callec-collection-events が GA4 へ送る(イベント名は pdrawer_*)
  function track(name, data) {
    try {
      if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
      var t = document.body.className.match(/template-[\w-]+/);
      Shopify.analytics.publish('callec:' + name, Object.assign({ template: t ? t[0] : '' }, data));
    } catch (err) {
      // 計測の失敗で操作を止めない
    }
  }

  function recentCards() {
    var track = recent && !recent.hidden && recent.querySelector('[data-cec-recent-track]');
    return track ? Array.prototype.filter.call(track.children, function (el) {
      return el.classList.contains('f-column');
    }) : [];
  }

  if (recent) {
    drawer.addEventListener('open', loadRecent);
    // ナビの「商品」に指が触れた時点で取りに行く(先読み前に押された場合の保険)
    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[data-drawer="#Drawer-CecProducts"]')) loadRecent();
    }, { passive: true });
    var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 1500); };
    var prefetch = function () { idle(loadRecent, { timeout: 3000 }); };
    if (document.readyState === 'complete') prefetch();
    else window.addEventListener('load', prefetch, { once: true });
  }

  // loadRecent の後に登録する(キャッシュから描画された枚数を数えるため)
  drawer.addEventListener('open', function () {
    track('pdrawer_open', { recent_count: recentCards().length });
  });

  // 押された場所を「最近見た商品 / 検索バー / それ以外のリンク」に分けて送る
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cec-sheet-search]')) {
      track('pdrawer_search_click', {});
      return;
    }
    var a = e.target.closest('a[href]');
    if (!a) return;
    var path = (a.getAttribute('href') || '').split('?')[0];
    var cards = recentCards();
    var card = recent && recent.contains(a) ? a.closest('.f-column') : null;
    if (card) {
      track('pdrawer_recent_click', {
        product: path,
        position: cards.indexOf(card) + 1,
        recent_count: cards.length
      });
    } else {
      track('pdrawer_link_click', { link: path });
    }
  });

  drawer.addEventListener('click', function (e) {
    // 2026-09-17 最上段の検索バー。商品ドロワーを閉じ、ヘッダーと同じ検索ドロワーを開く。
    // openDrawer はクリックの中で同期的に呼ぶ(iOS はユーザー操作の中でないとキーボードを出さない)
    var search = e.target.closest('[data-cec-sheet-search]');
    if (search) {
      e.preventDefault();
      var searchDrawer = document.getElementById('Drawer-Search');
      if (!searchDrawer || typeof searchDrawer.openDrawer !== 'function') {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search';
        return;
      }
      var opener = drawer.openedBy;
      drawer.closeDrawer(false);
      searchDrawer.openDrawer(opener || search);
      return;
    }

    var btn = e.target.closest('[data-cec-acc]');
    if (!btn) return;
    e.preventDefault();

    var item = btn.closest('.cec-sheet__item');
    var sub = item && item.querySelector('[data-cec-acc-body]');
    if (!sub) return;

    var opening = sub.hidden;
    btn.setAttribute('aria-expanded', opening ? 'true' : 'false');

    if (opening) {
      sub.hidden = false;
      var h = sub.scrollHeight;
      sub.style.maxHeight = '0px';
      sub.style.transition = 'max-height 0.32s cubic-bezier(0.2, 0.8, 0.2, 1)';
      window.requestAnimationFrame(function () {
        sub.style.maxHeight = h + 'px';
      });
      window.setTimeout(function () {
        sub.style.maxHeight = '';
        sub.style.transition = '';
      }, 340);
    } else {
      sub.style.maxHeight = sub.scrollHeight + 'px';
      sub.style.transition = 'max-height 0.28s cubic-bezier(0.2, 0.8, 0.2, 1)';
      window.requestAnimationFrame(function () {
        sub.style.maxHeight = '0px';
      });
      window.setTimeout(function () {
        sub.hidden = true;
        sub.style.maxHeight = '';
        sub.style.transition = '';
      }, 290);
    }
  });
})();
